<template>
   <div id="step3">

      <div class="wrapper stepUp">
        <div class="d23"></div>
      <div class= "formaWrap">
      <div class= "step">
        <p class= "stepWrap">1</p>
        <svg width="7" height="29" viewBox="0 0 7 29" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'nextstep'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.875 28.216a.593.593 0 01-.558-.794l4.586-12.739a1.4 1.4 0 000-.948L.317.996A.593.593 0 011.433.594l4.73 13.14a1.4 1.4 0 010 .95l-4.73 13.14a.593.593 0 01-.558.392z" fill="#000F38" fill-opacity=".2"/></svg>
        <p class= "stepWrap">2</p>
        <svg width="7" height="29" viewBox="0 0 7 29" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'nextstep'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.875 28.216a.593.593 0 01-.558-.794l4.586-12.739a1.4 1.4 0 000-.948L.317.996A.593.593 0 011.433.594l4.73 13.14a1.4 1.4 0 010 .95l-4.73 13.14a.593.593 0 01-.558.392z" fill="#000F38" fill-opacity=".2"/></svg>
        <p class= "stepWrap current">3</p>
        </div>
      <p class="fillContact">Укажите паспортные данные</p>
        <form action="" v-show="control">
             <div class="formaCont">

                 <div class="flex1">
                <div class="formCenter"><input type="text"  v-model="series"  placeholder="Серия паспорта" v-mask="'####'" v-on:blur="blurSeries">
                  <p v-if="errSerias.length > 0" class=errMsg>{{errSerias}}</p>
                </div>
                <div class="formCenter"><input type="text"  v-model="number" placeholder="Номер паспорта" v-mask="'######'" v-on:blur="blurnumber">
                <p v-if="errnumber.length > 0" class=errMsg>{{errnumber}}</p>
                 </div>
                   <div class="datePlaceholder formCenter">
                    <!-- <input type="text"  placeholder="Дата выдачи паспорта" v-if="!focused" class="fakeInput"> -->
                    <p  v-if="!focused" class="fakeInput">Дата выдачи паспорта</p>
                  <input type="date"  v-model="issueDate" placeholder="Дата выдачи паспорта"  v-on:blur="blurissueDate" v-on:focus="onFocus">
                  <p v-if="errissueDate.length > 0" class=errMsg>{{errissueDate}}</p>
                 </div>

                </div>

                <div class="flex2">
                  <div class="formCenter">
                  <input type="text"  v-model="officeCode" placeholder="Код подразделения" v-mask="'###-###'" v-on:blur="blurofficeCode">
                <p v-if="errofficeCode.length > 0" class=errMsg>{{errofficeCode}}</p>
                 </div>
                <div class="formCenter">
                   <selectDadata
                   class="grid"
                   :label="'Место выдачи паспорта'"
                  :refs="'office'"
                    ></selectDadata>

                 </div>
                </div>

                <div class="flex3">
                  <div class="formCenter">
                    <input type="text" v-model="birthPlace" placeholder="Место рождения" v-on:blur="blurbirthPlace">
                  <p v-if="errbirthPlace.length > 0" class=errMsg>{{errbirthPlace}}</p>

                </div>
                <div class="formCenter">
                  <input type="text" v-model="income" placeholder="Сумма постоянного дохода" v-on:blur="blurincome">
                   <p v-if="errincome.length > 0" class=errMsg>{{errincome}}</p>
                </div>
                <div class="sexCont formCenter">
                <p class="sexTxt">Ваш пол<p>

                <div class="sexCheck">
                <input type="radio"  value="M" v-model="sex">
                <label for="man">Мужской</label>
                <input type="radio"  value="F" v-model="sex">
                <label for="woman">Женский</label>

                </div>
                <p v-if="errsex.length>0" class=errMsgsex>{{errsex}}</p>

</div>
</div>
</div>


        </form>
                <button type="button" class="btn" v-on:click.prevent="nextStep" >Далее</button>

      </div>
      </div>
      </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'step3',
  data(){
return{
    control: true,
    picked: false,
    errSerias:'',
    errnumber:'',
    errissueDate:'',
    errofficeCode:'',
    erroffice:'',
    errbirthPlace:'',
    errincome:'',
    errsex:'',
    focused: false,
    refsStepArr:[{parent: "passport", key:"office" }],
}
},
computed:{
    ...mapState({
      valueVuex: state => state.alfaForm.alfaForm,
      statusVuex: state => state.alfaForm.checkResult,
      session:state=>state.alfaForm.session,
      AdditionalInfo:state=>state.alfaForm.AdditionalInfo,
    }),
    sex:{
        get(){
        return this.valueVuex['sex'];
      },
      set(value){
        this.errsex = '';
        this.$store.commit('setStateAlfaRoot',{
          formKey:'sex',
          value:value
        })
      }
    },
    series:{
      get(){
        return this.valueVuex["passport"]['series'];
      },
      set(value){
        this.$store.commit('setStateAlfaChildren',{
          parent: 'passport',
          formKey:'series',
          value:value
        })
      }
    },
        number:{
      get(){
        return this.valueVuex["passport"]['number'];
      },
      set(value){
        this.$store.commit('setStateAlfaChildren',{
          parent: 'passport',
          formKey:'number',
          value:value
        })
      }
    },
    issueDate:{
      get(){
        return this.valueVuex["passport"]['issueDate'];
      },
      set(value){
        this.$store.commit('setStateAlfaChildren',{
          parent: 'passport',
          formKey:'issueDate',
          value:value
        })
      }
    },
       officeCode:{
      get(){
        return this.valueVuex["passport"]['officeCode'];
      },
      set(value){
        this.$store.commit('setStateAlfaChildren',{
          parent: 'passport',
          formKey:'officeCode',
          value:value
        })
      }
    },
     office:{
      get(){
        return this.valueVuex["passport"]['office'];
      },
      set(value){
        this.$store.commit('setStateAlfaChildren',{
          parent: 'passport',
          formKey:'office',
          value:value
        })
      }
    },
    birthPlace:{
      get(){
        return this.valueVuex["passport"]['birthPlace'];
      },
      set(value){
        this.$store.commit('setStateAlfaChildren',{
          parent: 'passport',
          formKey:'birthPlace',
          value:value
        })
      }
    },
    income:{
      get(){
        return this.valueVuex["workInfo"]['income'];
      },
      set(value){
        this.$store.commit('setStateAlfaChildren',{
          parent: 'workInfo',
          formKey:'income',
          value:value
        })
      }
    },
},
components:{
    selectDadata:()=>import('@/components/alfaSelectDadataPassport')
  },
methods:{
//    nextStep(){
//  this.$store.commit('incStepForm')
//  },
checkFormFieldValue(){
        // проверяем заполнения полей
        let isFormFieldCorrect = true;
        this.refsStepArr.forEach(item => {
          if (this.statusVuex[item.parent][item.key].code != 0) {
            this.$store.dispatch('errorShow', {
              parent: item.parent,
              formKey: item.key,
            });
            isFormFieldCorrect = false;
          }
        });
        return isFormFieldCorrect;

      },
nextStep(){
      this.blurSeries();
      this.blurnumber();
      this.blurissueDate();
      this.blurofficeCode();
      this.bluroffice();
      this.blurbirthPlace();
      this.blurincome();
      this.checkSex();
      this.checkFormFieldValue()
      if (this.errSerias.length == 0
          &&  this.errnumber.length == 0
          &&  this.errissueDate.length == 0
          &&  this.erroffice.length == 0
          &&  this.errbirthPlace.length == 0
          &&  this.errincome.length == 0
          && this.errsex.length == 0
          && this.checkFormFieldValue()
          ){
           this.sendRequest();
             try {
            // eslint-disable-next-line
            ym(82222150, 'reachGoal', '3step')
          }
          catch(e){
            console.log(e)
          }
          }
},
onFocus() {
  console.log('tut')
      this.focused = true
    },
    checkSex(){

          let reqExp = /^[FM]$/;

                if (reqExp.test(this.sex)) {
                    this.errsex ='';
                } else {
                    this.errsex ='обязательное поле';
                }

    },
    blurSeries(){
       if (this.series.length == 0){
            this.errSerias ='обязательное поле';
        } else {

                let reqExp = /^[0-9]{4}$/;
                if (reqExp.test(this.series)) {
                    this.errSerias ='';
                } else {
                    this.errSerias ='некорректная серия паспорта';
                }


       }
    },
    blurnumber(){
       if (this.number.length == 0){
            this.errnumber ='обязательное поле';
        } else {

                let reqExp = /^[0-9]{6}$/;
                if (reqExp.test(this.number)) {
                    this.errnumber ='';
                } else {
                    this.errnumber ='некорректный номер';
                }


       }
    },
    blurissueDate(){
       if (this.issueDate.length == 0){
         this.focused = false;
            this.errissueDate ='обязательное поле';

    }else {
            this.errissueDate ='';
        }
    },
    blurofficeCode(){
       if (this.officeCode.length == 0){
            this.errofficeCode ='обязательное поле';
        } else {

                let reqExp = /^[0-9]{3}-[0-9]{3}$/;
                if (reqExp.test(this.officeCode)) {
                    this.errofficeCode ='';
                } else {
                    this.errofficeCode ='некорректный код';
                }


       }
    },
      bluroffice(){
       if (this.office.length == 0){
            this.erroffice ='обязательное поле';
        } else {

                let reqExp = /^[^a-zA-Z?*:]{1,254}$/;
                if (reqExp.test(this.office)) {
                    this.erroffice ='';
                } else {
                    this.erroffice ='некорректные данные';
                }


       }
    },
    blurbirthPlace(){
       if (this.birthPlace.length == 0){
            this.errbirthPlace ='обязательное поле';
        }else {
            this.errbirthPlace ='';
       }
        },

    blurincome(){
       if (this.income.length == 0){
            this.errincome ='обязательное поле';
        } else {

                let reqExp = /^[0-9]{1,10}$/;
                if (reqExp.test(this.income)) {
                    this.errincome ='';
                } else {
                    this.errincome ='некорректные данные';
                }


       }
    },


    sendRequest(){
//to do проверить что все поля заполены
      if(this.valueVuex['identicalAddresses']){
        this.$store.dispatch('updateAlfaFormValue',{
            formKey:'registrationAddress',
            parent:'',
            value: this.valueVuex['residentialAddress']
          });
          this.$store.dispatch('updateAlfaFormValue',{
            formKey:'registrationAddressUnrestricted_value',
            parent:'',
            value: this.valueVuex['residentialAddressUnrestricted_value']
          });
      }


      this.$store.commit('loadingStatus', true);

      this.$myApi.SendRequest({
            action:'saveAlfaRequest',
            Data: this.valueVuex,
            AdditionalInfo:this.AdditionalInfo,
            session:this.session
        }).then(res=>{
            //todo переход на страницу с кодом
        this.$store.dispatch('updateAlfaFormValue', {
          formKey: 'AlfaCard_FormSaved',
          parent: '',
          value: res
        });

        this.$myApi.singleRequest({
          action:'stepSave',
          step:'screen_3',
          result:res,
          stepCode:1,
          session:this.session
        }).then((res)=>{res['asd']='asd';}).catch((res)=>{res['asd']='asd';});

        this.$store.commit('incStepForm');
        }).catch(res=>{

          this.$myApi.singleRequest({
          action:'stepSave',
          step:'screen_3',
          result:res,
          stepCode:-1,
          session:this.session
        }).then((res)=>{res['asd']='asd';}).catch((res)=>{res['asd']='asd';});

          let err = this.$myApi.parseError(res,'SendAlfaECPConfCode');
          alert(err.ExecutionErrorMessage);
        }).finally(()=>{
        this.$store.commit('loadingStatus', false);
        });

    }
}
}
</script>

<style scoped>
.formaWrap{height: 200vw;top: -179vw;}
.sexCheck{display: flex; justify-content: center;align-items: center; column-gap: 3vw;}
.sexTxt{padding-bottom: 2vw; padding-top: 2vw;}
li{ list-style-type: none;}
.d23{height: 179vw; }
form{padding-bottom: 26vw;}
.sexTxt, .sexCheck {font-size: 3.7vw;}
#step3{ height: 218vw;}
input{margin-bottom: 4vw;}
/deep/.errMsg{color: red;position: absolute;font-size: 3vw;top: 12.5vw;width: 100%;}
.formaWrap {top: -192vw;height: 210vw;}
.d23 {height: 192vw;}
button{ position: absolute;bottom: 7vw;left: 23vw;}
.datePlaceholder .fakeInput {color: #676767;font-family: Arial, sans-serif;bottom: calc(50% - 1vw);pointer-events: none;position: absolute;background-color: #F5F6FC;left: calc(50% - 28.5vw);}
.formCenter{margin-left: auto; margin-right: auto; position: relative;}
input{width: 57vw; height: 4.5vw;}
input[type=radio]:not(:checked) {background-image: url('../assets/vector/radiobutton.svg');}
input[type=radio]:checked {background-image: url('../assets/vector/radiobuttoncheck.svg');}
input[type=radio] {width: 3vw;height: 3vw;-webkit-appearance: none;outline: 0;background-repeat: no-repeat;background-position: center center;background-size: contain;border:0px;margin-bottom: 0px;}
.errMsgsex{top:1.5vw;color: red;font-size: 3vw;}
input[type=date]{-webkit-appearance: none; }




@media screen and (min-width: 1140px) {
.sexTxt, .sexCheck{font-size: 20px;padding-top: 0px;}
input{font-size: 22px;padding: 14px 20px; margin-bottom: 0px;}
.formaWrap{height: 642px;top: -467px;}
.flex1{display: flex; gap: 20px;justify-content: center;}
.flex2{display: flex; gap: 20px;justify-content: center; margin-top: 20px;margin-bottom: 20px;}
.flex3{display: flex; gap: 20px;justify-content: center;}
.grid{width: 703px;}
#step3{ height: 674px; }
.d23{ height: 467px;}
form{padding-bottom: 112px;}
.sexCheck{column-gap: 15px;}
.sexTxt{padding-bottom: 5px; padding-top: 0px;}
/deep/.errMsg{top: 67px;font-size: 16px;}
button{left: 390px; position: absolute;bottom: 40px;}
input{width: 293px; height: 35px;}
.formCenter{width: 100%; margin-left: 0; margin-right: 0; }
input[type=radio] { width: 30px;height: 30px;}
.errMsgsex{font-size: 16px;}
.errorMsg{top: 8px;}
.datePlaceholder .fakeInput {left: calc(50% - 146.5px);font-size: 22px;bottom: calc(50% - 12px);}
}

</style>
